import { api } from "../../helpers/api/handler"

export const isLoggedIn = () => api.get<boolean>("/auth/heartbeat/")
